import script from "./MaterialIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialIcon.vue?vue&type=script&setup=true&lang=js"

import "./MaterialIcon.vue?vue&type=style&index=0&id=42cdcde6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42cdcde6"]])

export default __exports__